import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Route,
  Switch,
  Redirect,
} from 'react-router-dom';
import {
  selectUserClientId,
  selectIsAuthenticated,
  setCurrentUser,
  setCurrentSession,
} from '../store/authSlice';
import {
  selectCompanyCode,
  getCompanyByClientId,
  getCompanyByCode,
} from '../store/widgetSlice';

// Views
import Home from '../views/CompactHome';
import Data from '../views/Data';
import Import from '../views/Import';
import Settings from '../views/Settings';
import Admin from '../views/Admin';
import Review from '../views/Review';
import Widget from '../views/Widget';
import PopUpWidget from '../views/PopUpWidget';
import Verification from '../views/Verification';
import VerificationNext from '../views/VerificationNext';
import VerificationCreation from '../views/VerificationCreation';
import KnowledgeBase from '../views/KnowledgeBase';
import LeadGeneration from '../views/LeadGeneration';
import CardReview from '../views/CardReview';
import Scan from '../views/Scan';
import Demo from '../views/Demo';

const PrivateRoute = ({ component: Component, auth, ...props }) => (
  <Route
    {...props}
    render={(componentProps) => (
      auth
        ? <Component {...componentProps} />
        : <Redirect to="/login" />
    )}
  />
);

export default function Routes() {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const clientId = useSelector(selectUserClientId);
  const companyCode = useSelector(selectCompanyCode);

  useEffect(() => {
    dispatch(setCurrentUser());
    dispatch(setCurrentSession());
  }, [dispatch]);

  useEffect(() => {
    if (clientId) {
      dispatch(getCompanyByClientId({ clientId }));
    } else if (companyCode) {
      dispatch(getCompanyByCode({ companyCode }));
    }
  }, [dispatch, clientId, companyCode]);

  return (
    <Switch>
      <Route path="/widget/:reference" component={PopUpWidget} />
      <Route path="/widget" component={Widget} />
      <Route path="/admin" component={Admin} />
      <Route path="/verify/next" component={VerificationNext} />
      <Route path="/verify/:reference" component={Verification} />
      <Route path="/verify/" component={Verification} />
      <Route path="/scan/:reference" component={Scan} />
      <Route path="/reviews/:reviewId" component={Review} />
      <Route path="/get-in-touch" component={LeadGeneration} />
      <Route path="/demo" component={Demo} />
      <Route path="/card-review/:type" component={CardReview} />
      <Route path="/card-review" component={CardReview} />
      <PrivateRoute auth={isAuthenticated} exact path="/" component={Home} />
      <PrivateRoute auth={isAuthenticated} exact path="/create-verification" component={VerificationCreation} />
      <PrivateRoute auth={isAuthenticated} exact path="/verifications" component={Data} />
      <PrivateRoute auth={isAuthenticated} exact path="/settings" component={Settings} />
      <PrivateRoute auth={isAuthenticated} exact path="/import" component={Import} />
      <PrivateRoute auth={isAuthenticated} exact path="/knowledge-base" component={KnowledgeBase} />
    </Switch>
  );
}
